export const defaultApiBaseUrl =
  import.meta.env.VITE_API_BASE_URL || "https://dev.agentapp.enaible.biz";

export const defaultSamsApiBaseUrl = import.meta.env.VITE_SAMS_API_BASE_URL || "";

export const defaultReplayLabBaseUrl =
  import.meta.env.VITE_REPLAY_LAB_BASE_URL ||
  defaultSamsApiBaseUrl ||
  `${window.location.origin}/replay-lab`;

// The main login is the SAMS Supabase project: the SAMS host verifies this
// token and Base does not accept it. No key default, so a build without one
// says so on the login page instead of signing in to another project.
export const supabaseUrl =
  import.meta.env.VITE_SUPABASE_URL ||
  "https://itarkhddrrokcaswcxdn.supabase.co";

export const supabasePublishableKey =
  import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY || "";
